import { TableColumn } from "../table/TableColumn";

const InstallPeripheralsColumns: TableColumn[] = [
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 1,
        sortByName: "fixedAddress",
        active: true,
        translationKey: "fixedAddress"
    },
]

export default InstallPeripheralsColumns;
